import controllerRegistry from '@ngenic/controllers/controller-register';

up.compiler('[ngenic-controller]', (element: HTMLElement) => {
    const controllerName = up.element.attr(element, 'ngenic-controller');
    const controllerData = up.element.jsonAttr(element, 'controller-data');
    const controller = controllerRegistry.createInstance(controllerName, element, controllerData);

    controller.init();

    return () => {
        controller.destroy();
    }
});